import { render, staticRenderFns } from "./GridAttachment.vue?vue&type=template&id=49e4a2d5&"
import script from "./GridAttachment.vue?vue&type=script&lang=js&"
export * from "./GridAttachment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports